import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import { closeGlobalSnackbar } from '../../actions/global_snackbar';

const SnackbarMessage = incomingProps => {
  const props = {
    ...{
      global_snackbar: { open: false, message: '' },
    },
    ...incomingProps,
  };
  return (
    <div>
      <Snackbar
        open={props.global_snackbar.open}
        message={props.global_snackbar.message}
        onClose={props.closeGlobalSnackbar}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </div>
  );
};

SnackbarMessage.propTypes = {
  closeGlobalSnackbar: PropTypes.func.isRequired,
  global_snackbar: PropTypes.object,
};

function mapStateToProps(state) {
  // eslint-disable-next-line camelcase
  const { global_snackbar } = state;
  return {
    global_snackbar,
  };
}

export default connect(mapStateToProps, { closeGlobalSnackbar })(
  SnackbarMessage,
);
